import { defaultFor } from "common";
import type { Context } from "common/types/context";
import type {
  SiteChangedDetails,
  SitesChangedEvent,
} from "common/types/events";
import { Row } from "common/record/form/content/audit-trail/event-detail/row";
import { getEventLocalizedName } from "common/record/form/content/audit-trail/utils";
import { DateTimeLabel } from "common/widgets/date/date-time-label";
import { SitesLabel } from "common/widgets/site-selector/sites-label";

interface PropTypes {
  context: Context;
  event: SitesChangedEvent;
}

export const SitesChanged = ({ event, context }: PropTypes) => {
  if (!event) return <span />;

  const { uiFormat } = context;
  const { details: eventDetails, name, userName } = event;

  const details = eventDetails ?? defaultFor<SiteChangedDetails>();
  const { occurredOn, sitesBefore, sitesAfter } = details;

  return (
    <div className="qa-sites-changed">
      <legend>{getEventLocalizedName(name, userName)}</legend>
      <Row label={_("User Name")}>{userName}</Row>
      {!!occurredOn && (
        <Row label={_("Occurred On")}>
          <DateTimeLabel uiFormat={uiFormat} value={occurredOn} />
        </Row>
      )}
      <Row label={_("Sites Before")}>
        <SitesLabel context={context} value={sitesBefore} />
      </Row>
      <Row label={_("Sites After")}>
        <SitesLabel context={context} value={sitesAfter} />
      </Row>
    </div>
  );
};
